import { useMemo } from 'react';

import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';

import type { HandType, OptionsFilter, PotStruct } from '../utils/common';
import { fallback } from '../utils/common';

export type GameTypeOptions = OptionsFilter & {
  propName: 'handType' | 'potStruct';
};

interface TextOption {
  handType: {
    [key in HandType]: string;
  };
  potStruct: {
    [key in PotStruct]: string;
  };
}

const textOptionsMap: TextOption = {
  handType: {
    HT_HOLDEM: "Hold'em",
    HT_OMAHA: 'Omaha'
  },
  potStruct: {
    STRUCT_NO_LIMIT: 'No Limit',
    STRUCT_POT_LIMIT: 'Pot Limit'
  }
};

const useGetGameOrGameType = ({ gameData, propName, values }: GameTypeOptions): SelectOption[] =>
  useMemo(() => {
    if (!gameData || !gameData.length) return fallback;
    const data =
      propName === 'potStruct'
        ? gameData.filter((item) => item.handType === values.handType)
        : gameData;

    const textOptions = textOptionsMap[propName];
    const options = [...new Set(data.map((item) => item[propName]))].map((item) => ({
      text: textOptions[item as string],
      value: item
    }));

    if (!options || !options.length) return fallback;

    return options;
  }, [gameData, propName, values]);

export default useGetGameOrGameType;
